/**
 * Runs a route update. Native document.startViewTransition is not used here because it
 * often reports "Transition was skipped" with React concurrent rendering + flushSync.
 */
export function withViewTransition(updateFn) {
  updateFn();
}
